import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, ClientViewModel, JwTokenModel, UserModel, UserViewModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { ClientsApiService, UsersApiService } from "../../core/api/services";
import { Table } from "primeng/table";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";



@Component({
  selector: 'app-users-component',
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
  standalone: false
})
export class UsersComponent implements OnInit, AfterViewInit {
  

  public pageTitle: string = 'Users';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;

  itemFormGroup!: FormGroup;
  currentItem?: UserModel;
  loading: boolean = false;

  resetPasswordVisible: boolean = false;
  newPassword: string | null = null;
  clients: any[] | null = null;
  loadingClients: boolean = false;

  clientUsers: any[][] | null = null;
  loadingClientUser: boolean = false;

  get UserHasClients() {
    return this.itemFormGroup.controls["UserHasClients"] as FormArray;
  }

  
  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: UsersApiService,
    private clientsApiService: ClientsApiService,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {

    
    this.route.queryParams.subscribe(params => {
      let userId = +params['userId'];
    });



    this.authService.checkIfAutorized([ArkUserType.Admin]);



    this.itemFormGroup = this.formBuilder.group(
      {

        //userId: [],
        UserName: ['', [Validators.required, Validators.maxLength(50)]],

        FirstName: ['', [Validators.maxLength(255)]],
        LastName: ['', [Validators.maxLength(255)]],
        Email: ['', [Validators.maxLength(255), Validators.email, Validators.required]],
        PhoneNumber: ['', [Validators.maxLength(25)]],

        GitHub_Username: ['', [Validators.maxLength(50)]],
        GitHub_AccessToken: ['', [Validators.maxLength(50)]],
        ValidIPAddresses: ['', [Validators.maxLength(1000)]],

        NotificationOnNewSupportTicket: [false, []],
//        companyDepartmentUsers: this.formBuilder.array([]),

        UserTypes: [],
        UserHasClients: this.formBuilder.array([])
      });


  }

  ngAfterViewInit(): void {


  }


  loadTable(event: any) {

    this.filter = Utils.normalizePrimeDatatableEvent(event || { filters: {} });

    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }


  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {
    this.alertService.info('TO DO');
  }



  onRowEditInit(item: UserViewModel) {
    this.loadingList = true;

    this.apiService.Get({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }

  onRowDeleteInit(item: UserViewModel) {
    this.alertService.confirm('Confirm', `Are you sure you want to delete ${item.UserName}?`).subscribe(response => {
      if (response) {
        this.apiService.Delete({ body: { id: item.ID ||0 } })
          .forEach(
            (ok) => {
              this.loadTable(null);
              this.alertService.success('Item deleted successfully');
            }).catch(
              (err) => {
                this.alertService.error(Utils.getAjaxError(err));
              });

      }
    });

  }

  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    this.itemFormGroup.clearValidators();


    this.UserHasClients.clear();
    if (this.currentItem.UserHasClients)
      this.currentItem.UserHasClients.forEach(t => {
        var item: FormGroup = this.newUserHasClient();
        this.UserHasClients.push(item);
      });

    this.itemFormGroup.patchValue(this.currentItem);

    if (this.clients == undefined) {
      this.loadingClients = true;
      this.clientsApiService.List({ body: { sortField: 'SiteName'} }).forEach(clients => {
        this.clients = clients.Result || null;
        this.loadingClients = false;
      })
    }
  }
  clientSelected(form: any) {
    let formGroup = form as FormGroup;
    console.debug('clientSelected', formGroup.get('ClientID')?.value);
  }


  arkUserTypes: any[] = [
    { value: ArkUserType.Admin, text: 'Admin' },
    { value: ArkUserType.Developer, text: 'Developer' },
    { value: ArkUserType.Impersonator, text: 'Impersonator' },
    { value: ArkUserType.Marketing, text: 'Marketing' },
    { value: ArkUserType.Support, text: 'Support' },
  ]


  getDisplayValue(values: ArkUserType[]) {
    if (values == null || values.length == 0)
      return '-';
    return this.arkUserTypes.filter(x => values.indexOf(x.value) >= 0) .map(x => x.text).join(', ');
  }


  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();


    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(newItem);


    this.loading = true;
    this.apiService.Save({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }).catch(
          (err) => {
            this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });


  }


  newUserHasClient() {
    return this.formBuilder.group({
      ClientID: [0],
      Client_UserID: [0],
      SiteName: ['', [ Validators.maxLength(50)]],
      Client_Username: ['', [Validators.maxLength(250)]]
    });
  }

  addUserHasClient() {
    this.UserHasClients.push(this.newUserHasClient());
  }
  deleteUserHasClient(taskIndex: number) {
    this.UserHasClients.removeAt(taskIndex);
  }



  searchClient(event: AutoCompleteCompleteEvent) {

  }
  resetTwoFactor() {

    if (!this.currentItem?.HasOneTimePasswordKey || !this.currentItem?.ID || !this.currentItem) {
      this.alertService.error('Userd does not have 2 factor  One Time Password Key ');
      return;
    }

    
    this.alertService.confirm('Confirm', `Are you sure you want to reset 2 factor for ${this.currentItem.UserName}?`).forEach(response => {
      if (response) {
        this.loading = true;
        this.apiService.ResetTwoFactor({ body: { userID: this.currentItem!.ID || 0 } }).forEach(() => {
          this.loading = false;
          this.currentItem!.HasOneTimePasswordKey = false;
          this.currentItem!.WebAuthnCredentialId = null;
          this.alertService.info('Ok');
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loading = false;
          }).
          finally(() => {
          });
      }
    });
    
  }

  resetPassword() {
    this.newPassword = Utils.generatePassword(24);
    this.resetPasswordVisible = true;
  }

  resetPasswordConfirm() {

    // generate random password
    
    this.loading = true;
    this.apiService.SetPassword({ body: { userID: this.currentItem!.ID || 0, password: this.newPassword!  } }).forEach(() => {
      this.loading = false;
      this.resetPasswordVisible = false;
      this.alertService.info('Password set: ' + this.newPassword);
    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });
  }
}
